import { Dialog } from '@headlessui/react'
import { useSnapshot } from 'valtio'
import React, { type ReactElement } from 'react'
import { rpOccurrenceProxy } from '../../../rpOccurrenceProxy'
import { recurringPaymentProxy } from '../../../../../../../../shared/proxies/recurringPaymentProxy'
import { executeRecurringTransactionResolve } from '../../utils/executeRecurringTransactionResolve'
import OutlineButton from '../../../../../../../../shared/components/ui/buttons/OutlineButton'
import { NormalButton } from '../../../../../../../../shared/components/ui/buttons/NormalButton'
import { PaymentResolveRadioValues } from '../../utils/PaymentResolveRadioValues'
import { RecurringPaymentStatus } from '../../../../../../../../shared/types/GlobalRecurringPaymentsStatus'
import { ResumeChargesSection } from './ResumeChargesSection'

export function ConfirmResolveModal (): ReactElement | null {
  const { displayResolveModal } = useSnapshot(rpOccurrenceProxy)
  const { recurringPayment, resolveRadioValue } = useSnapshot(recurringPaymentProxy)

  const disabledSubmit = (resolveRadioValue === PaymentResolveRadioValues.RESUME_PAYMENT && !recurringPaymentProxy.nextPaymentDate)

  if (recurringPayment == null) {
    return null
  }

  return (
    <Dialog
      open={displayResolveModal}
      onClose={() => { rpOccurrenceProxy.displayResolveModal = false }}
      className="fixed z-10 inset-0 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

        <div className="relative bg-white rounded max-w-xl mx-auto p-5">
          <Dialog.Title>
            <div className="mb-4">
              <div className="text-2xl font-medium text-center">Resume Recurring and Resolve?</div>

            </div>
          </Dialog.Title>

          <ResumeChargesSection isActive={recurringPayment.status === RecurringPaymentStatus.Active} />

          <div className="flex flex-row justify-center">
            <OutlineButton additionalClasses="w-full py-2 my-2 mx-1" clickFunction={() => { rpOccurrenceProxy.displayResolveModal = false }} text="Cancel" />
            <NormalButton disabled={disabledSubmit} additionalClasses="w-full py-2 my-2 mx-1" onClick={executeRecurringTransactionResolve} text="Resolve" />

          </div>
        </div>
      </div>

    </Dialog>
  )
}
